module.exports = __webpack_public_path__ + "media/images/information-9197753f.png";